import client from './client'

export async function getStatus() {
  await client().get('/_status')
}
